import React from 'react';
import VoucherPage from './VoucherPage';

const VpsSsdPage: React.FC = () => {
  return <VoucherPage category="vpsSsd" />;
};

export default VpsSsdPage;

